<div class="d-flex flex-column py-5"
     style="background: url('/assets/img/dropdown-bg.jpg');background-size: cover;background-position: center;">
  <h5 class="d-flex flex-center">
    <span class="white">{{'lang.globals.notifications' | translate}}</span>
    <a class="ml-2" style="padding: 0; background: none !important;" [sbRouterLink]="util.RoutingID.notification"
       [queryParams]="{page:1, isRead:0, isArchived:0, exactMatch: false}">
            <span class="font-weight-bold btn btn-danger btn-sm">
                {{notificationService.totalPendingNotificationsCount > 999 ? '999 +' :
              notificationService.totalPendingNotificationsCount}}
            </span>
    </a>
  </h5>
</div>
<!--- hier den ngFor --->
<div class="navi py-3">
  <ng-scrollbar style="height: 450px" [track]="'vertical'">
    <ng-container *ngFor="let notification of notificationService.pendingNotifications">
      <ng-container *ngIf="notification.routerLink">
        <a ngbDropdownItem class="navi-item" [sbRouterLink]="util.RoutingID.notification">
          <div class="navi-link notification-link">
            <div class="navi-attachment mr-2">
              <ng-container [ngSwitch]="notification.logLevel">
                <sb-icon *ngSwitchCase="'info'" icon="details" class="blue"></sb-icon>
                <sb-icon *ngSwitchCase="'warning'" icon="attention" class="yellow"></sb-icon>
                <sb-icon *ngSwitchCase="'error'" icon="error" class="red"></sb-icon>
                <sb-icon *ngSwitchDefault icon="questionmark"></sb-icon>
              </ng-container>
            </div>
            <div class="navi-text notification-infos">
              <div class="font-weight-bold" [title]="notification.name" [innerHTML]="notification.name"></div>
              <div class="text-muted" [title]="notification.message" [innerHTML]="notification.message"></div>
            </div>
            <div class="d-flex">
              <button *ngPermissions="permissionService.Permission.notification_read" (click)="check($event, notification)"
                      ngbTooltip="{{'lang.globals.markAsRead' | translate}}" placement="right"
                      container="body" style="padding-left:0.7rem; padding-right:0.7rem"
                      class="btn btn-hover-primary btn-sm">
                <sb-icon icon="checked"></sb-icon>
              </button>
            </div>
          </div>
        </a>
      </ng-container>
      <ng-container *ngIf="!notification.routerLink">
        <a ngbDropdownItem class="navi-item">
          <div class="navi-link">
            <div class="navi-attachment mr-2">
              <ng-container [ngSwitch]="notification.logLevel">
                <sb-icon *ngSwitchCase="'info'" icon="details" class="blue"></sb-icon>
                <sb-icon *ngSwitchCase="'warning'" icon="attention" class="yellow"></sb-icon>
                <sb-icon *ngSwitchCase="'error'" icon="error" class="red"></sb-icon>
                <sb-icon *ngSwitchDefault icon="questionmark"></sb-icon>
              </ng-container>
            </div>
            <div class="navi-text">
              <div class="font-weight-bold" [innerHTML]="notification.name | truncate : 35">
              </div>
              <div class="text-muted" [innerHTML]="notification.message | truncate : 40">
              </div>
            </div>
            <div class="d-flex">
              <button *ngPermissions="permissionService.Permission.notification_read" (click)="check($event, notification)"
                      ngbTooltip="{{'lang.globals.markAsRead' | translate}}" placement="right"
                      container="body" style="padding-left: 0.3rem;padding-right: 0.3rem;"
                      class="btn btn-hover-primary btn-sm">
                <sb-icon icon="checked"></sb-icon>
              </button>
            </div>
          </div>
        </a>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="notificationService.pendingNotificationsCount === 0">
      <a ngbDropdownItem class="navi-item" [sbRouterLink]="util.RoutingID.notification"
         [queryParams]="{page:1, isRead:0, isArchived:0, exactMatch: false}">
        <div class="navi-link" (mouseleave)="hover = false" (mouseenter)="hover = true">
          <div class="navi-attachment mr-2">
            <sb-icon icon="thumbsUp" [hover]="hover"></sb-icon>
          </div>
          <div class="navi-text">
            <div class="font-weight-bold">
              {{'lang.notifications.youAreUpToSpeed' | translate}}
            </div>
          </div>
        </div>
      </a>
    </ng-container>
  </ng-scrollbar>
  <ng-container *ngIf="notificationService.morePendingNotificationsCount > 0">
    <a ngbDropdownItem class="navi-item" [sbRouterLink]="util.RoutingID.notification"
       [queryParams]="{page:1, isRead:0, isArchived:0, exactMatch: false}">
      <div class="navi-link">
        <div class="navi-attachment mr-2">
          <sb-icon icon="plus"></sb-icon>
        </div>
        <div class="navi-text">
          <div class="font-weight-bold">
            {{notificationService.morePendingNotificationsCount | sbNumberFormat}}&nbsp;{{ 'lang.globals.moreThreeDots' | translate }}
          </div>
        </div>
      </div>
    </a>
  </ng-container>
</div>
